export function surveysBetaListPath(clientId?: string): string {
  return clientId ? `/client/${clientId}/surveys/beta` : '/surveys/beta';
}

/** Matches classic `/surveys/create` — a NEVER tab under SurveysPage (full top nav). */
export function surveysBetaEditPath(
  extSurveyId: string,
  clientId?: string
): string {
  const base = clientId
    ? `/client/${clientId}/surveys/beta-create`
    : '/surveys/beta-create';
  return `${base}?ext-survey-id=${encodeURIComponent(extSurveyId)}`;
}

export function surveysBetaResultsPath(
  extSurveyId: string,
  clientId?: string
): string {
  return clientId
    ? `/client/${clientId}/results/api-overview/${extSurveyId}`
    : `/results/api-overview/${extSurveyId}`;
}
